export default "__VITE_ASSET__Dv1q455$__"